// @flow
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { T } from 'ramda';

import { api } from 'app/api';
import { GET_CAFETERIA_CUSTOMER_COMPLEXES, convertParams, convertResult } from 'app/common/api/requests/cafeteria/customer/orders/complexes';
import type { ComplexMap } from 'app/common/components/Cafeteria/dataTypes/order/Complex.types';
import SimpleDate from 'app/common/classes/simple-date';


type Options = {
  customerId: string,
  date: SimpleDate,
  orderRequestId: string,
  onSuccess?: (itemsMap: ComplexMap) => Promise<boolean>,
  onFailure?: () => void | Promise<void>
}

export default function useComplexesRequest(options: Options): [
  () => Promise<boolean>,
  boolean
] {
  const { t } = useTranslation('cafeteria');

  const { date, customerId, orderRequestId, onSuccess = T, onFailure } = options;
  const [loading, setLoading] = useState(true);

  const request = useCallback(async (): Promise<boolean> => {
    setLoading(true);

    const res = await api.request(GET_CAFETERIA_CUSTOMER_COMPLEXES, {
      error: t('order_request_sales_put_on_food_complects_fetch_error', 'Не удалось получить комплекты блюд'),
      params: {
        date,
        customerId,
        orderRequestId,
      },
      convertions: {
        convertParams,
        convertResult,
      },
    });

    if (res) {
      const res2 = await onSuccess(res);
      if (res2) {
        setLoading(false);
        return true;
      }
    }
    if (onFailure) {
      onFailure();
    }
    return false;
  }, [date, customerId, orderRequestId, onSuccess, t, onFailure]);

  return [request, loading];
}
